/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {EntityElementModel} from '../../../shared/entity-tree/entity-element/models/entity-element.model';
import {EntityElementActionsEnum} from '../../../shared/entity-tree/entity-element/models/entity-element-actions.enum';
import {EntityTreeBranchModel} from '../../../shared/entity-tree/models/entity-tree-branch.model';
import {EntityTreeBranchDisplayDataModel} from '../configuration/v1/models/entity-tree-branch-display-data.model';

@Injectable({
    providedIn: 'root'
})
export class BusinessSettingsUtil {

    constructor() {
    }

    /**
     * Sorts an {@link EntityElementModel[]} by sorting code field.
     * @param elements the {@link EntityElementModel[]} to sort
     * @return EntityElementModel[] the sorted array
     */
    sortEntityElementBySortingCode(elements: EntityElementModel[]): EntityElementModel[] {
        return elements?.sort(this.sortingCodeComparator) ?? [];
    }

    sortingCodeComparator(a: EntityElementModel, b: EntityElementModel): number {
        const elementA = a.sortingCode?.toUpperCase();
        const elementB = b.sortingCode?.toUpperCase();
        return (elementA < elementB) ? -1 : (elementA > elementB) ? 1 : 0;
    }

    /**
     * Convert an object into an {@link EntityElementModel}
     * @param element the object to convert
     * @param configuration the configuration with mapping specifications
     * @param data the data with context menu actions
     * @param action the {@link EntityElementActionsEnum} to be added to the {@link EntityElementModel}.
     * Default value: {@link EntityElementActionsEnum.EDIT}
     * @param sortByParentCode if the array elements should be sorted by the parent code instead of their own code
     * @return EntityElementModel
     */
    mapToEntityElementModel(element: any,
                            configuration: EntityTreeBranchModel,
                            data: EntityTreeBranchDisplayDataModel,
                            action: EntityElementActionsEnum = EntityElementActionsEnum.EDIT,
                            sortByParentCode?: boolean): EntityElementModel {

        if (element != null && configuration != null && data != null) {

            const initialMapConfiguration = {
                name: configuration.displayNameFunction != null ? configuration.displayNameFunction(element) : element.name,
                code: element.code,
                hasDisplayCode: configuration.hasDisplayCode,
                displayCode: configuration.hasDisplayCode ?
                        (configuration.displayCodeFunction != null ? configuration.displayCodeFunction(element) : element.code) : null,
                active: element.active,
                action: action,
                contextMenuActions: [...data.contextMenuActions],
                originalValue: element,
                currentValue: element,
                childrenCode: configuration.childrenCodeFunction != null ? configuration.childrenCodeFunction(element) : null,
                iconCode: configuration.hasIconFunction != null && configuration.iconCode != null
                && configuration.hasIconFunction(element) ? configuration.iconCode : null,
                breadcrumbLabel: configuration.breadcrumbLabelFunction?.(element)
            } as EntityElementModel;

            if (sortByParentCode) {
                return initialMapConfiguration;
            } else {
                initialMapConfiguration.sortingCode = configuration.sortingValueFunction != null ?
                        configuration.sortingValueFunction(element) : element.name;
                return initialMapConfiguration;
            }
        }
        return null;
    }
}
